import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class MinimumDepositLimitConfig {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isMinimumDepositLimitEnabled(): boolean {
		return this.config.get(
			(x) => x.commonUi.responsibleGaming.minimumDepositLimit!.isMinimumDepositLimitEnabled,
			false
		);
	}

	getDepositLimitMinValue(): number {
		return this.config.get((x) => x.commonUi.responsibleGaming.minimumDepositLimit!.depositLimitMin, Infinity);
	}

	getDepositLimitMinThresholdValue(): number {
		return this.config.get((x) => x.commonUi.responsibleGaming.setDepositLimitMin, 1);
	}
}
